import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import Checkbox from "../../../../components/common/checkbox/Checkbox";
import { Field } from "redux-form";
import arrowUp from "../../../../assets/images/arrow-up.svg";
import arrowDown from "../../../../assets/images/arrow-down.svg";
import styles from "./Accordion.scss";

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSkills: false,
      count: props.selectedNumber || 0,
      open: false
    };
  }

  handleCheckbox(skill, checked) {
    if (checked) {
      this.setState({ count: this.state.count + 1 });
      this.props.checkTotalSkills(true);
    } else {
      this.setState({ count: this.state.count - 1 });
      this.props.checkTotalSkills(false);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedNumber !== nextProps.selectedNumber) {
      this.setState({ count: nextProps.selectedNumber });
    }
  }

  render() {
    return (
      <Panel eventKey={this.props.id} className={styles.panel}>
        <Panel.Heading className={styles.panelHeading}>
          <Panel.Title
            toggle
            className={styles.title}
            onClick={() => this.setState({ open: !this.state.open })}
          >
            <div className={styles.titleContainer}>
              <div className={styles.checkboxContainer}>{this.props.name}</div>
              <div className={styles.checkboxContainer}>
                <div className={styles.selected}>
                  {this.state.count > 0 ? this.state.count + " selected " : ""}
                </div>
                {this.state.open ? (
                  <img src={arrowUp} />
                ) : (
                  <img src={arrowDown} />
                )}
              </div>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible className={styles.panelBody}>
          {this.props.skills &&
            this.props.skills.map(el => (
              <Field
                key={el.id}
                name={`skills[${el.id}]`}
                onCheck={checked => this.handleCheckbox(el, checked)}
                text={el.name}
                component={Checkbox}
                eleId={el.id}
              />
            ))}
        </Panel.Body>
      </Panel>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/routes/candidate/professionalSkills/components/Accordion.js